import useCustomModal, {UseCustomModalProps} from "./useCustomModal";
import {IPopulatedJob} from "../../types/FrontendTypes.ts";
import {Box, Typography} from "@mui/material";
import JobRest from "../../rest/JobRest.ts";
import React from "react";
import ImageRest from "../../rest/ImageRest.ts";
import {ModalJobCard} from "./ModalCards/ModalJobCard.tsx";
import {ModalCutterCard} from "./ModalCards/ModalCutterCard.tsx";
import {Dangerous} from "@mui/icons-material";

export interface AbortJobModalProps {
    job?: IPopulatedJob;
    jobRest: JobRest;
    imageRest: ImageRest;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    afterAbort?: (newJob: any) => void;
}

export const useAbortJobModal = (props: AbortJobModalProps) => {
    const {job, jobRest, imageRest, afterAbort} = props;
    let modalOptions: UseCustomModalProps;

    if (job) {
        const content =
            <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                <Typography>Please confirm, if you want to abort the job</Typography>
                <ModalJobCard job={job} imageRest={imageRest}/>
                <Typography>that is currently being executed on this cutter:</Typography>
                <ModalCutterCard cutter={job.cutter} imageRest={imageRest}/>
            </Box>

        modalOptions = {
            title: "Abort running job?",
            customContent: content,
            defaultAction: {
                label: "Abort",
                method: () => jobRest.abort(job._id).then(afterAbort),
                icon: <Dangerous/>,
                color: "error"
            },
            cancelAction: {
                label: "Cancel",
            },
        };
    } else {
        modalOptions = {
            title: "Error",
            contentText: "The job data is not available. Please try again later.",
            defaultAction: {
                label: "Close",
                method: () => {
                },
            },
            cancelAction: {
                label: "Cancel",
            },
        };
    }

    const {open} = useCustomModal(modalOptions);

    return open;
};

export default useAbortJobModal;